import React, { useState, useMemo } from 'react';
import { Collapse, Icon } from 'antd';
import { ReportCicloOrcamentario, GraficoEconomicoCicloAnualProjeto } from '../../api/relatorios';
import GraficoCurva from '../GraficoCurva/index'

const { Panel } = Collapse;


interface PropGrafico {
  projetoId: string;
}

const Graficos = (props: PropGrafico) => {
  const { projetoId } = props;
  const [relatorio, setRelatorio] = useState<ReportCicloOrcamentario>();

  useMemo(() => {
    if (projetoId) {
      GraficoEconomicoCicloAnualProjeto(projetoId).then((data) => {
        setRelatorio(data);
      });
    }
  }, [projetoId]);

  return (
    <>
      {relatorio ? <GraficoCurva relatorio={relatorio} carregarTabela={true} /> : <> </>}
    </>
  );
};

export default Graficos;
